import React from 'react';
import { graphql } from 'gatsby';
import Head from '../components/Head';
import PwpGrid from '../components/PwpGrid';
import { Helmet } from 'react-helmet';

export default function Devices({ data: { contentfulPage }, location }) {
  const heading = contentfulPage.heading;
  const description = contentfulPage.description;
  const imageUrl = contentfulPage.thumbnail.image?.file.url;

  if (process.env.GATSBY_BUILD_WITH_BRANDING === 'webex') {
    return (
      <>
        <Helmet
          style={[
            {
              cssText: `
            body {
              display:none;
            }
          `,
            },
          ]}
        />
        <meta http-equiv="refresh" content="0;url=https://www.webex.com/collaboration-devices.html" />
      </>
    );
  } else {
    return (
      <>
        <Head location={location} title={heading} description={description} image={imageUrl} />
        <PwpGrid pageData={contentfulPage} />
      </>
    );
  }
}

export const query = graphql`
  query {
    contentfulPage(id: { eq: "89a1c18c-35ec-5473-b39e-054e823f5db2" }) {
      heading
      description {
        raw
      }
      thumbnail {
        ...PwpImage
      }
      sections {
        ...GridDevice
        ...MultiPage
      }
    }
  }
`;
